var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_vm._l((_vm.projects),function(project){return _c('Project',{key:project.name,staticClass:"md-layout-item md-size-25",attrs:{"project":project.name}})}),(!_vm.projects.length)?_c('Help'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }